export enum EchoEvents {
   BatchJobStarted = '.BatchJobStarted',
   BatchJobUpdated = '.BatchJobUpdate',
   BatchJobDone = '.BatchJobDone',
}
